import { accountsReceivableVisibilityRules } from '../../accountsReceivable/accountsReceivable.visibility.rules';
import { targetVisibilityRules } from '../../target/target.visibility.rules';
import { VisibilityRuleMap } from '../types/featureVisibility.types';
import { homeVisibilityRules } from './home.visibility.rules';
import { menuVisibilityRules } from './menu.visibility.rules';

export const featureVisibilityRules: VisibilityRuleMap = {
  ...accountsReceivableVisibilityRules,
  ...menuVisibilityRules,
  ...homeVisibilityRules,
  ...targetVisibilityRules,
};
